var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0096 3.81766C15.4498 2.47641 14.6659 0.960759 13.5718 0.117144C12.9836 -0.336265 12.3777 0.641814 12.9587 1.08946C13.5784 1.5673 14.089 2.44191 13.9649 3.23494C14.3321 3.37517 14.6855 3.57255 15.0096 3.81766ZM12.7158 3.28033V3.56767V3.28033ZM14.7579 4.35293C14.4577 4.10984 14.1215 3.90928 13.766 3.77252C13.4261 3.6418 13.0701 3.56764 12.7156 3.56764C11.7361 3.56792 10.7657 4.12935 10.1724 5.59821C8.44556 9.87252 3.86322 13.2116 2.86708 13.9411C2.07953 14.5178 -1.94481 16.2998 1.15949 16.2998C1.98239 16.2998 3.30642 16.1745 5.32433 15.8682C14.9542 14.4071 15.884 7.30092 15.884 7.30092C16.2572 6.26886 15.6854 5.10316 14.7579 4.35293ZM13.8149 9.96188C13.4417 10.6015 12.4481 10.0234 12.8225 9.38175C13.3546 8.46977 14.8272 6.73631 13.4595 5.96568C12.8138 5.60192 13.3931 4.60892 14.0396 4.97325C16.2112 6.19704 14.7182 8.41346 13.8149 9.96188Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.da8f7e14.svg";
export { ForwardRef as ReactComponent };